module.exports = __webpack_public_path__ + "static/media/blackooppah.af6ea709.png";